import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';

function PostDetail({ favorites, toggleFavorite }) {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const posts = {
    1: {
      id: 1,
      title: 'Οι Καλύτερες Ασκήσεις για Δύναμη και Αντοχή',
      image: '/images/1.jpg',
      date: '15 Ιανουαρίου 2025',
      category: 'Προπόνηση',
      content: `
        <p>Η ανάπτυξη δύναμης και αντοχής είναι θεμελιώδης για κάθε πρόγραμμα προπόνησης. Ανεξάρτητα από το αν στοχεύετε στην απώλεια βάρους, την αύξηση της μυϊκής μάζας ή απλά στη βελτίωση της γενικής σας φυσικής κατάστασης, η σωστή προπόνηση δύναμης και αντοχής είναι το κλειδί για την επιτυχία.</p>

        <h2>Βασικές Ασκήσεις Ενδυνάμωσης</h2>
        <p>Οι σύνθετες ασκήσεις είναι ο ακρογωνιαίος λίθος κάθε αποτελεσματικού προγράμματος. Το squat, το deadlift, το bench press και το overhead press είναι οι τέσσερις βασικές ασκήσεις που πρέπει να συμπεριλάβετε στην προπόνησή σας. Αυτές οι ασκήσεις ενεργοποιούν πολλαπλές μυϊκές ομάδες ταυτόχρονα, οδηγώντας σε μεγαλύτερη ανάπτυξη μυϊκής μάζας και αύξηση της δύναμης.</p>

        <h3>Το Squat - Ο Βασιλιάς των Ασκήσεων</h3>
        <p>Το squat είναι μία από τις πιο ολοκληρωμένες ασκήσεις που μπορείτε να κάνετε. Ενεργοποιεί τους τετρακέφαλους, τους οπίσθιους μηριαίους, τους γλουτούς και τον πυρήνα. Για να εκτελέσετε σωστά ένα squat, διατηρήστε την πλάτη σας ευθεία, κατεβαίνετε μέχρι τα μηρά σας να είναι παράλληλα με το έδαφος και σπρώξτε μέσω των φτερνών σας για να επιστρέψετε στην αρχική θέση.</p>

        <h2>Προπόνηση Αντοχής για Μέγιστα Αποτελέσματα</h2>
        <p>Η καρδιοαναπνευστική αντοχή είναι εξίσου σημαντική με τη μυϊκή δύναμη. Η συνδυασμένη προπόνηση δύναμης και αντοχής οδηγεί σε βέλτιστα αποτελέσματα. Προτείνουμε να συνδυάζετε υψηλής έντασης διαλειμματική προπόνηση με παραδοσιακή προπόνηση αντοχής.</p>

        <h3>HIIT - Υψηλής Έντασης Διαλειμματική Προπόνηση</h3>
        <p>Το HIIT είναι μία από τις πιο αποτελεσματικές μεθόδους για την καύση λίπους και τη βελτίωση της καρδιοαναπνευστικής αντοχής. Μια τυπική προπόνηση HIIT διαρκεί 20-30 λεπτά και περιλαμβάνει εναλλαγές υψηλής έντασης άσκησης με σύντομες περιόδους ανάκαμψης.</p>

        <h2>Πρόγραμμα Εβδομαδιαίας Προπόνησης</h2>
        <p>Ένα ισορροπημένο εβδομαδιαίο πρόγραμμα θα πρέπει να περιλαμβάνει τρεις ημέρες προπόνησης δύναμης και δύο ημέρες καρδιοαναπνευστικής προπόνησης, με δύο ημέρες ανάκαμψης. Αυτό επιτρέπει στους μύες σας να αναρρώσουν ενώ συνεχίζετε να προοδεύετε.</p>

        <p><strong>Δευτέρα:</strong> Προπόνηση άνω σώματος με έμφαση στη δύναμη</p>
        <p><strong>Τρίτη:</strong> HIIT καρδιοαναπνευστική προπόνηση</p>
        <p><strong>Τετάρτη:</strong> Ημέρα ανάκαμψης ή ήπια δραστηριότητα</p>
        <p><strong>Πέμπτη:</strong> Προπόνηση κάτω σώματος με έμφαση στη δύναμη</p>
        <p><strong>Παρασκευή:</strong> Μικτή προπόνηση αντοχής</p>
        <p><strong>Σάββατο:</strong> Πλήρης προπόνηση σώματος</p>
        <p><strong>Κυριακή:</strong> Ημέρα ανάκαμψης</p>

        <h2>Διατροφή για Δύναμη και Αντοχή</h2>
        <p>Η διατροφή παίζει κρίσιμο ρόλο στην ανάπτυξη δύναμης και αντοχής. Χρειάζεστε επαρκή πρωτεΐνη για την επιδιόρθωση και ανάπτυξη των μυών, σύνθετους υδατάνθρακες για ενέργεια και υγιή λιπαρά για την ορμονική ισορροπία.</p>

        <p>Στοχεύστε σε τουλάχιστον 1.6-2.2 γραμμάρια πρωτεΐνης ανά κιλό σωματικού βάρους την ημέρα. Συμπεριλάβετε πολλά φρούτα και λαχανικά για τις απαραίτητες βιταμίνες και μέταλλα, και μην ξεχνάτε να παραμένετε ενυδατωμένοι.</p>

        <h2>Συμπέρασμα</h2>
        <p>Η ανάπτυξη δύναμης και αντοχής απαιτεί χρόνο, υπομονή και συνέπεια. Ακολουθήστε ένα δομημένο πρόγραμμα, φάτε σωστά, ξεκουραστείτε επαρκώς και τα αποτελέσματα θα έρθουν. Θυμηθείτε, η πρόοδος δεν είναι πάντα γραμμική, αλλά με αφοσίωση και σκληρή δουλειά, θα επιτύχετε τους στόχους σας.</p>
      `
    },
    2: {
      id: 2,
      title: 'Διατροφικός Οδηγός για Μέγιστη Απόδοση',
      image: '/images/2.jpg',
      date: '12 Ιανουαρίου 2025',
      category: 'Διατροφή',
      content: `
        <p>Η σωστή διατροφή είναι το θεμέλιο κάθε επιτυχημένου προγράμματος fitness. Ανεξάρτητα από το πόσο σκληρά προπονείστε, χωρίς τη σωστή καύσιμο, το σώμα σας δεν θα μπορέσει να επιτύχει τη μέγιστη απόδοση και ανάκαμψη.</p>

        <h2>Τα Τρία Βασικά Μακροθρεπτικά Συστατικά</h2>
        <p>Για να κατανοήσετε τη διατροφή για απόδοση, πρέπει πρώτα να κατανοήσετε τα τρία κύρια μακροθρεπτικά συστατικά: πρωτεΐνες, υδατάνθρακες και λιπαρά. Το καθένα έχει ξεχωριστό ρόλο στο σώμα σας και είναι απαραίτητο για βέλτιστη απόδοση.</p>

        <h3>Πρωτεΐνες - Οι Δομικοί Λίθοι των Μυών</h3>
        <p>Η πρωτεΐνη είναι απαραίτητη για την επιδιόρθωση και ανάπτυξη των μυών. Μετά από μια έντονη προπόνηση, οι μύες σας χρειάζονται πρωτεΐνη για να επιδιορθώσουν τις μικροσκοπικές ρήξεις που δημιουργούνται κατά την άσκηση. Οι καλύτερες πηγές πρωτεΐνης περιλαμβάνουν κοτόπουλο, ψάρι, αυγά, γαλοπούλα, ελληνικό γιαούρτι και φυτικές πηγές όπως τα όσπρια και το τόφου.</p>

        <p>Για άτομα που προπονούνται τακτικά, συνιστάται η κατανάλωση 1.6-2.2 γραμμαρίων πρωτεΐνης ανά κιλό σωματικού βάρους την ημέρα. Αυτή η ποσότητα διασφαλίζει ότι το σώμα σας έχει αρκετή πρωτεΐνη για τη σύνθεση μυϊκών πρωτεϊνών και την ανάκαμψη.</p>

        <h3>Υδατάνθρακες - Η Κύρια Πηγή Ενέργειας</h3>
        <p>Οι υδατάνθρακες είναι η κύρια πηγή καυσίμου για το σώμα σας, ειδικά κατά τη διάρκεια έντονης προπόνησης. Αποθηκεύονται στους μύες και το συκώτι ως γλυκογόνο και χρησιμοποιούνται για ενέργεια κατά την άσκηση. Επιλέξτε σύνθετους υδατάνθρακες όπως βρώμη, γλυκοπατάτες, καφέ ρύζι και ολικής άλεσης προϊόντα για σταθερή απελευθέρωση ενέργειας.</p>

        <h3>Υγιή Λιπαρά - Απαραίτητα για την Υγεία</h3>
        <p>Τα υγιή λιπαρά είναι κρίσιμα για την ορμονική παραγωγή, την απορρόφηση βιταμινών και τη συνολική υγεία. Συμπεριλάβετε πηγές όπως αβοκάντο, ξηρούς καρπούς, σπόρους, ελαιόλαδο και λιπαρά ψάρια στη διατροφή σας.</p>

        <h2>Χρονοδιάγραμμα Διατροφής</h2>
        <p>Το πότε τρώτε μπορεί να είναι εξίσου σημαντικό με το τι τρώτε. Η κατάλληλη χρονική στιγμή των γευμάτων σας μπορεί να βελτιώσει την απόδοση και την ανάκαμψη.</p>

        <h3>Πριν την Προπόνηση</h3>
        <p>Φάτε ένα γεύμα πλούσιο σε υδατάνθρακες και μέτριο σε πρωτεΐνη 2-3 ώρες πριν από την προπόνηση. Αυτό θα παρέχει την απαραίτητη ενέργεια χωρίς να αισθάνεστε βαριά. Αν χρειάζεστε κάτι πιο κοντά στην προπόνηση, επιλέξτε ένα ελαφρύ σνακ 30-60 λεπτά πριν.</p>

        <h3>Μετά την Προπόνηση</h3>
        <p>Το παράθυρο ανάκαμψης μετά την προπόνηση είναι κρίσιμο. Στοχεύστε να καταναλώσετε πρωτεΐνη και υδατάνθρακες εντός 30-60 λεπτών μετά την προπόνηση για να μεγιστοποιήσετε τη σύνθεση μυϊκών πρωτεϊνών και να αναπληρώσετε τα αποθέματα γλυκογόνου.</p>

        <h2>Ενυδάτωση - Το Ξεχασμένο Θρεπτικό Συστατικό</h2>
        <p>Το νερό είναι ζωτικής σημασίας για όλες τις σωματικές λειτουργίες, συμπεριλαμβανομένης της μυϊκής λειτουργίας και ανάκαμψης. Στοχεύστε σε τουλάχιστον 2-3 λίτρα νερό την ημέρα, με περισσότερο αν προπονείστε έντονα ή σε ζεστό περιβάλλον.</p>

        <h2>Συμπληρώματα Διατροφής</h2>
        <p>Ενώ τα συμπληρώματα δεν είναι απαραίτητα, ορισμένα μπορούν να είναι χρήσιμα. Η κρεατίνη, η πρωτεΐνη ορού γάλακτος και τα BCAA είναι μερικά από τα πιο ερευνημένα και αποτελεσματικά συμπληρώματα για την απόδοση και την ανάκαμψη.</p>

        <h2>Συμπέρασμα</h2>
        <p>Η διατροφή για μέγιστη απόδοση δεν είναι περίπλοκη, αλλά απαιτεί σχεδιασμό και συνέπεια. Επικεντρωθείτε στην κατανάλωση επαρκούς πρωτεΐνης, ποιοτικών υδατανθράκων και υγιών λιπαρών. Μείνετε ενυδατωμένοι και προγραμματίστε τα γεύματά σας γύρω από τις προπονήσεις σας. Με τον χρόνο, αυτές οι συνήθειες θα γίνουν δεύτερη φύση και θα δείτε σημαντική βελτίωση στην απόδοση και τα αποτελέσματά σας.</p>
      `
    },
    3: {
      id: 3,
      title: 'Πώς να Χτίσετε Μυϊκή Μάζα Γρήγορα',
      image: '/images/3.jpg',
      date: '10 Ιανουαρίου 2025',
      category: 'Μύες',
      content: `
        <p>Η ανάπτυξη μυϊκής μάζας είναι ένας από τους πιο συνηθισμένους στόχους στο γυμναστήριο, αλλά και ένας από τους πιο παρεξηγημένους. Ενώ πολλοί πιστεύουν ότι χρειάζεται μόνο σκληρή προπόνηση, η πραγματικότητα είναι ότι η ανάπτυξη μυών απαιτεί έναν ολιστικό συνδυασμό προπόνησης, διατροφής και ανάκαμψης.</p>

        <h2>Η Επιστήμη πίσω από τη Μυϊκή Ανάπτυξη</h2>
        <p>Η μυϊκή υπερτροφία συμβαίνει όταν οι μυϊκές ίνες υφίστανται μικροσκοπικές βλάβες κατά την άσκηση και στη συνέχεια επιδιορθώνονται και μεγαλώνουν κατά την ανάκαμψη. Αυτή η διαδικασία απαιτεί τρεις βασικούς παράγοντες: μηχανική τάση, μυϊκή βλάβη και μεταβολικό στρες.</p>

        <h3>Προοδευτική Υπερφόρτωση - Το Κλειδί της Ανάπτυξης</h3>
        <p>Το πιο σημαντικό κομμάτι για την ανάπτυξη μυών είναι η προοδευτική υπερφόρτωση. Αυτό σημαίνει ότι με την πάροδο του χρόνου, πρέπει να αυξάνετε σταδιακά τη δυσκολία των προπονήσεών σας. Μπορείτε να το κάνετε αυτό αυξάνοντας το βάρος, τον αριθμό των επαναλήψεων, το πλήθος των σετ, ή μειώνοντας τους χρόνους ανάπαυσης.</p>

        <h2>Βέλτιστη Δομή Προπόνησης για Υπερτροφία</h2>
        <p>Για μέγιστη μυϊκή ανάπτυξη, συνιστάται η προπόνηση κάθε μυϊκής ομάδας τουλάχιστον δύο φορές την εβδομάδα. Ένα αποτελεσματικό πρόγραμμα θα μπορούσε να είναι η διαίρεση push pull legs ή η διαίρεση άνω κάτω σώματος.</p>

        <h3>Εύρος Επαναλήψεων και Σετ</h3>
        <p>Για υπερτροφία, το ιδανικό εύρος επαναλήψεων είναι 6-12 επαναλήψεις ανά σετ. Αυτό το εύρος παρέχει τον βέλτιστο συνδυασμό μηχανικής τάσης και μεταβολικού στρες. Στοχεύστε σε 3-5 σετ ανά άσκηση και 10-20 σετ ανά μυϊκή ομάδα την εβδομάδα.</p>

        <h3>Χρόνος Υπό Τάση</h3>
        <p>Ο χρόνος που ο μυς είναι υπό τάση είναι κρίσιμος για την υπερτροφία. Στοχεύστε σε σετ που διαρκούν 40-70 δευτερόλεπτα, με ελεγχόμενες κινήσεις και έμφαση στην εκκεντρική φάση της άσκησης.</p>

        <h2>Διατροφή για Μυϊκή Μάζα</h2>
        <p>Χωρίς επαρκή θερμίδες και θρεπτικά συστατικά, το σώμα σας δεν μπορεί να χτίσει νέο μυϊκό ιστό. Για να αυξήσετε τη μυϊκή μάζα, χρειάζεστε ένα θερμιδικό πλεόνασμα 300-500 θερμίδες πάνω από τα επίπεδα συντήρησής σας.</p>

        <h3>Πρωτεΐνη για Ανάπτυξη</h3>
        <p>Η πρωτεΐνη είναι απαραίτητη για τη σύνθεση μυϊκών πρωτεϊνών. Καταναλώστε τουλάχιστον 2 γραμμάρια πρωτεΐνης ανά κιλό σωματικού βάρους την ημέρα. Κατανείμετε αυτήν την πρωτεΐνη ομοιόμορφα σε 4-6 γεύματα για μέγιστη σύνθεση μυϊκών πρωτεϊνών.</p>

        <h3>Υδατάνθρακες και Λιπαρά</h3>
        <p>Μην παραμελείτε τους υδατάνθρακες και τα λιπαρά. Οι υδατάνθρακες παρέχουν την απαραίτητη ενέργεια για έντονες προπονήσεις και βοηθούν στην ανάκαμψη. Τα υγιή λιπαρά είναι κρίσιμα για την παραγωγή τεστοστερόνης και άλλων αναβολικών ορμονών.</p>

        <h2>Ανάκαμψη και Ύπνος</h2>
        <p>Οι μύες σας δεν μεγαλώνουν στο γυμναστήριο - μεγαλώνουν κατά την ανάκαμψη. Διασφαλίστε ότι παίρνετε επαρκή ύπνο, στοχεύοντας σε 7-9 ώρες ποιοτικού ύπνου κάθε βράδυ. Κατά τη διάρκεια του ύπνου, το σώμα απελευθερώνει αυξητική ορμόνη και άλλες αναβολικές ορμόνες που είναι κρίσιμες για τη μυϊκή ανάπτυξη.</p>

        <h3>Ενεργητική Ανάκαμψη</h3>
        <p>Ενσωματώστε τεχνικές ενεργητικής ανάκαμψης όπως ελαφριά καρδιοαναπνευστική άσκηση, διατάσεις και μασάζ. Αυτές οι τεχνικές βελτιώνουν την κυκλοφορία του αίματος και επιταχύνουν την απομάκρυνση μεταβολικών παραπροϊόντων από τους μύες.</p>

        <h2>Κοινά Λάθη που Πρέπει να Αποφύγετε</h2>
        <p>Πολλοί αθλητές κάνουν το λάθος της υπερπροπόνησης, θεωρώντας ότι περισσότερη προπόνηση σημαίνει περισσότερη ανάπτυξη. Η πραγματικότητα είναι ότι η υπερπροπόνηση μπορεί να οδηγήσει σε τραυματισμούς και να εμποδίσει την πρόοδο. Ακούστε το σώμα σας και δώστε του τον χρόνο που χρειάζεται για ανάκαμψη.</p>

        <h2>Συμπέρασμα</h2>
        <p>Η ανάπτυξη μυϊκής μάζας είναι μια μαραθώνια διαδρομή, όχι σπριντ. Επικεντρωθείτε στην προοδευτική υπερφόρτωση, φάτε σωστά με επαρκή πρωτεΐνη και θερμίδες, και δώστε προτεραιότητα στην ανάκαμψη. Με υπομονή και συνέπεια, θα δείτε εντυπωσιακά αποτελέσματα. Θυμηθείτε, η ποιότητα είναι πιο σημαντική από την ποσότητα - εκτελέστε κάθε άσκηση με σωστή τεχνική και ελέγξτε κάθε επανάληψη.</p>
      `
    },
    4: {
      id: 4,
      title: 'Καρδιοαναπνευστική Προπόνηση: Ο Πλήρης Οδηγός',
      image: '/images/4.jpg',
      date: '08 Ιανουαρίου 2025',
      category: 'Καρδιο',
      content: `
        <p>Η καρδιοαναπνευστική προπόνηση είναι θεμελιώδης για τη συνολική υγεία και φυσική κατάσταση. Δεν πρόκειται μόνο για την απώλεια βάρους - είναι για την ενίσχυση της καρδιάς σας, τη βελτίωση της αντοχής σας και την αύξηση της ποιότητας ζωής σας.</p>

        <h2>Τα Οφέλη της Καρδιοαναπνευστικής Άσκησης</h2>
        <p>Η τακτική καρδιοαναπνευστική άσκηση προσφέρει πολλαπλά οφέλη που επεκτείνονται πέρα από το γυμναστήριο. Βελτιώνει την καρδιαγγειακή υγεία, αυξάνει την ικανότητα των πνευμόνων, βοηθά στη διαχείριση του βάρους και μειώνει τον κίνδυνο χρόνιων ασθενειών όπως ο διαβήτης και οι καρδιακές παθήσεις.</p>

        <h3>Βελτίωση της Καρδιαγγειακής Υγείας</h3>
        <p>Η τακτική καρδιοαναπνευστική άσκηση ενισχύει την καρδιά σας, καθιστώντας την πιο αποτελεσματική στην άντληση αίματος. Αυτό σημαίνει ότι η καρδιά σας χρειάζεται να κτυπήσει λιγότερες φορές για να μεταφέρει το ίδιο ποσό αίματος, μειώνοντας την πίεση στο καρδιαγγειακό σύστημά σας.</p>

        <h2>Είδη Καρδιοαναπνευστικής Προπόνησης</h2>
        <p>Υπάρχουν πολλές μορφές καρδιοαναπνευστικής προπόνησης, καθεμία με τα δικά της μοναδικά οφέλη και χαρακτηριστικά.</p>

        <h3>Σταθερής Κατάστασης Καρδιοαναπνευστική Άσκηση</h3>
        <p>Αυτό περιλαμβάνει τη διατήρηση μιας σταθερής, μέτριας έντασης για παρατεταμένη περίοδο. Παραδείγματα περιλαμβάνουν τρέξιμο σε σταθερό ρυθμό, ποδηλασία ή κολύμβηση. Αυτός ο τύπος άσκησης είναι εξαιρετικός για την οικοδόμηση βασικής αντοχής και την καύση λίπους.</p>

        <h3>HIIT - Προπόνηση Υψηλής Έντασης με Διαλείμματα</h3>
        <p>Το HIIT περιλαμβάνει σύντομες περιόδους έντονης προσπάθειας ακολουθούμενες από περιόδους ανάκαμψης. Αυτή η μέθοδος είναι εξαιρετικά αποτελεσματική για την καύση θερμίδων, τη βελτίωση της καρδιαγγειακής λειτουργίας και την εξοικονόμηση χρόνου. Μια τυπική προπόνηση HIIT μπορεί να διαρκέσει μόλις 20 λεπτά.</p>

        <h3>Fartlek Προπόνηση</h3>
        <p>Το Fartlek είναι μια σουηδική λέξη που σημαίνει παιχνίδι ταχύτητας. Αυτή η μέθοδος συνδυάζει στοιχεία από τη σταθερή κατάσταση και το HIIT, επιτρέποντάς σας να παίξετε με διαφορετικές εντάσεις κατά τη διάρκεια της προπόνησής σας. Είναι μια διασκεδαστική και ευέλικτη προσέγγιση που μπορεί να γίνει σε οποιοδήποτε περιβάλλον.</p>

        <h2>Πώς να Δομήσετε το Καρδιοαναπνευστικό σας Πρόγραμμα</h2>
        <p>Το ιδανικό καρδιοαναπνευστικό πρόγραμμα εξαρτάται από τους στόχους σας και το τρέχον επίπεδο φυσικής κατάστασής σας.</p>

        <h3>Για Αρχάριους</h3>
        <p>Ξεκινήστε με 20-30 λεπτά μέτριας έντασης καρδιοαναπνευστικής άσκησης, 3-4 φορές την εβδομάδα. Αυτό μπορεί να είναι γρήγορο περπάτημα, ποδηλασία ή κολύμβηση. Καθώς χτίζετε αντοχή, αυξάνετε σταδιακά τη διάρκεια και την ένταση.</p>

        <h3>Για Μέτριου Επιπέδου</h3>
        <p>Προσθέστε ποικιλία στο πρόγραμμά σας. Συνδυάστε σταθερής κατάστασης καρδιοαναπνευστική άσκηση με προπονήσεις HIIT. Στοχεύστε σε 30-45 λεπτά, 4-5 φορές την εβδομάδα.</p>

        <h3>Για Προχωρημένους</h3>
        <p>Ενσωματώστε περιοδοποίηση στο πρόγραμμά σας. Αλλάξτε μεταξύ εβδομάδων υψηλού όγκου, υψηλής έντασης και ανάκαμψης. Προσθέστε προχωρημένες τεχνικές όπως Tabata intervals ή προπονήσεις tempo runs.</p>

        <h2>Καρδιοαναπνευστική και Προπόνηση Δύναμης</h2>
        <p>Ένα συχνό ερώτημα είναι πώς να συνδυάσετε την καρδιοαναπνευστική προπόνηση με την προπόνηση δύναμης. Το κλειδί είναι η ισορροπία και ο προγραμματισμός.</p>

        <h3>Χρονοδιάγραμμα</h3>
        <p>Αν ο στόχος σας είναι η μυϊκή ανάπτυξη, κάντε την καρδιοαναπνευστική προπόνηση μετά την προπόνηση δύναμης ή σε ξεχωριστές ημέρες. Αν ο στόχος σας είναι η αντοχή ή η καύση λίπους, μπορείτε να δώσετε προτεραιότητα στην καρδιοαναπνευστική προπόνηση.</p>

        <h2>Διατροφή για Καρδιοαναπνευστική Απόδοση</h2>
        <p>Η σωστή διατροφή είναι κρίσιμη για τη μέγιστη καρδιοαναπνευστική απόδοση. Πριν από μια καρδιοαναπνευστική προπόνηση, καταναλώστε ένα ελαφρύ γεύμα πλούσιο σε υδατάνθρακες για καύσιμο. Μετά την προπόνηση, επικεντρωθείτε στην αναπλήρωση των αποθεμάτων γλυκογόνου και την επιδιόρθωση των μυών με υδατάνθρακες και πρωτεΐνη.</p>

        <h2>Παρακολούθηση της Προόδου σας</h2>
        <p>Η παρακολούθηση της προόδου σας είναι σημαντική για τη διατήρηση του κινήτρου και την προσαρμογή του προγράμματός σας. Χρησιμοποιήστε ένα ρολόι fitness για να παρακολουθείτε τον καρδιακό σας ρυθμό, την απόσταση και τις θερμίδες που καίγονται. Κρατήστε ημερολόγιο προπόνησης για να παρακολουθείτε τις προπονήσεις σας και τα επίπεδα ενέργειάς σας.</p>

        <h2>Συμπέρασμα</h2>
        <p>Η καρδιοαναπνευστική προπόνηση είναι ένα ισχυρό εργαλείο για τη βελτίωση της συνολικής υγείας και φυσικής κατάστασής σας. Ανεξάρτητα από το αν είστε αρχάριος ή προχωρημένος αθλητής, υπάρχει μια καρδιοαναπνευστική προπόνηση που ταιριάζει στις ανάγκες και τους στόχους σας. Ξεκινήστε αργά, είστε συνεπείς και παρακολουθήστε πώς το σώμα σας μεταμορφώνεται.</p>
      `
    },
    5: {
      id: 5,
      title: 'Ανάκαμψη και Αποκατάσταση Μετά την Προπόνηση',
      image: '/images/5.jpg',
      date: '05 Ιανουαρίου 2025',
      category: 'Ανάκαμψη',
      content: `
        <p>Η ανάκαμψη είναι το πιο παραμελημένο κομμάτι του fitness, αλλά είναι εξίσου σημαντική με την ίδια την προπόνηση. Χωρίς σωστή ανάκαμψη, το σώμα σας δεν μπορεί να επιδιορθώσει τους μύες, να αναπληρώσει τα αποθέματα ενέργειας ή να προσαρμοστεί στις απαιτήσεις της προπόνησης.</p>

        <h2>Γιατί η Ανάκαμψη Είναι Σημαντική</h2>
        <p>Κατά τη διάρκεια της προπόνησης, δημιουργείτε μικροσκοπικές ρήξεις στις μυϊκές ίνες σας. Αυτές οι ρήξεις είναι φυσιολογικές και απαραίτητες για τη μυϊκή ανάπτυξη. Ωστόσο, η πραγματική ανάπτυξη και η ενίσχυση συμβαίνουν κατά την ανάκαμψη, όχι κατά την προπόνηση.</p>

        <h3>Οι Επιπτώσεις της Ανεπαρκούς Ανάκαμψης</h3>
        <p>Χωρίς επαρκή ανάκαμψη, κινδυνεύετε να εισέλθετε σε κατάσταση υπερπροπόνησης. Τα συμπτώματα περιλαμβάνουν χρόνια κόπωση, μειωμένη απόδοση, αυξημένο κίνδυνο τραυματισμών, διαταραχές ύπνου και εξασθενημένο ανοσοποιητικό σύστημα.</p>

        <h2>Τα Βασικά Στοιχεία της Ανάκαμψης</h2>
        <p>Η αποτελεσματική ανάκαμψη περιλαμβάνει πολλαπλές στρατηγικές που λειτουργούν συνεργατικά για να βοηθήσουν το σώμα σας να θεραπευτεί και να γίνει δυνατότερο.</p>

        <h3>Ύπνος - Ο Απόλυτος Ανακάμπτης</h3>
        <p>Ο ύπνος είναι όταν το σώμα σας κάνει το μεγαλύτερο μέρος της θεραπείας και ανάκαμψής του. Κατά τη διάρκεια του βαθέως ύπνου, το σώμα απελευθερώνει αυξητική ορμόνη, η οποία είναι κρίσιμη για την επιδιόρθωση και ανάπτυξη των μυών. Στοχεύστε σε 7-9 ώρες ποιοτικού ύπνου κάθε βράδυ.</p>

        <h3>Διατροφή για Ανάκαμψη</h3>
        <p>Η κατανάλωση των σωστών θρεπτικών συστατικών μετά την προπόνηση είναι κρίσιμη για την ανάκαμψη. Το παράθυρο μετά την προπόνηση είναι ιδανικό για την αναπλήρωση των αποθεμάτων γλυκογόνου και την έναρξη της διαδικασίας επιδιόρθωσης των μυών.</p>

        <p><strong>Πρωτεΐνη:</strong> Καταναλώστε 20-40 γραμμάρια πρωτεΐνης υψηλής ποιότητας εντός 30-60 λεπτών μετά την προπόνηση. Αυτό παρέχει τα απαραίτητα αμινοξέα για τη σύνθεση μυϊκών πρωτεϊνών.</p>

        <p><strong>Υδατάνθρακες:</strong> Οι υδατάνθρακες αναπληρώνουν τα αποθέματα γλυκογόνου των μυών. Η αναλογία υδατανθράκων προς πρωτεΐνη πρέπει να είναι περίπου 3:1 για βέλτιστη ανάκαμψη.</p>

        <h3>Ενυδάτωση</h3>
        <p>Η αφυδάτωση επιβραδύνει τη διαδικασία ανάκαμψης και επηρεάζει την απόδοση. Πίνετε νερό πριν, κατά τη διάρκεια και μετά την προπόνηση. Ένας καλός κανόνας είναι να πίνετε 500-700ml νερό για κάθε κιλό βάρους που χάνετε κατά την προπόνηση.</p>

        <h2>Ενεργητικές Τεχνικές Ανάκαμψης</h2>
        <p>Πέρα από την παθητική ανάπαυση, υπάρχουν πολλές ενεργητικές στρατηγικές που μπορούν να επιταχύνουν την ανάκαμψη.</p>

        <h3>Ελαφριά Καρδιοαναπνευστική Άσκηση</h3>
        <p>Η ελαφριά καρδιοαναπνευστική άσκηση αυξάνει την κυκλοφορία του αίματος χωρίς να προσθέτει σημαντική καταπόνηση στο σώμα. Αυτό βοηθά στην απομάκρυνση των μεταβολικών παραπροϊόντων και στη μεταφορά θρεπτικών συστατικών στους μύες. Δοκιμάστε 20-30 λεπτά περπάτημα, ποδηλασία ή κολύμβηση με χαμηλή ένταση.</p>

        <h3>Διατάσεις και Yoga</h3>
        <p>Οι διατάσεις βελτιώνουν την ευελιξία, μειώνουν τη μυϊκή τάση και βοηθούν στην πρόληψη τραυματισμών. Το yoga συνδυάζει διατάσεις με βαθιά αναπνοή και χαλάρωση, προσφέροντας ολιστικά οφέλη ανάκαμψης. Αφιερώστε τουλάχιστον 10-15 λεπτά για διατάσεις μετά από κάθε προπόνηση.</p>

        <h3>Αυτομασάζ και Foam Rolling</h3>
        <p>Το foam rolling είναι μια μορφή αυτομασάζ που βοηθά στην απελευθέρωση μυοπεριτονιακής τάσης και στη βελτίωση της κυκλοφορίας του αίματος. Εστιάστε σε περιοχές που αισθάνονται σφιχτές ή πονεμένες, αφιερώνοντας 30-60 δευτερόλεπτα σε κάθε μυϊκή ομάδα.</p>

        <h2>Προηγμένες Τεχνικές Ανάκαμψης</h2>
        <p>Για όσους θέλουν να προχωρήσουν περαιτέρω, υπάρχουν προηγμένες τεχνικές που μπορούν να ενισχύσουν την ανάκαμψη.</p>

        <h3>Θεραπεία με Ψύχος και Θερμότητα</h3>
        <p>Η εναλλαγή μεταξύ ψυχρού και θερμού νερού βελτιώνει την κυκλοφορία και μπορεί να μειώσει τη φλεγμονή. Το ψυχρό νερό συσπά τα αιμοφόρα αγγεία, ενώ το θερμό τα διαστέλλει, δημιουργώντας μια αντλητική δράση που απομακρύνει μεταβολικά απόβλητα.</p>

        <h3>Αθλητικό Μασάζ</h3>
        <p>Το επαγγελματικό αθλητικό μασάζ μπορεί να βοηθήσει στην απομάκρυνση του γαλακτικού οξέος, στη μείωση της μυϊκής τάσης και στη βελτίωση της ευελιξίας. Σκεφτείτε να προγραμματίζετε τακτικές συνεδρίες, ειδικά μετά από έντονες προπονήσεις.</p>

        <h3>Συμπλήρωμα για Ανάκαμψη</h3>
        <p>Ορισμένα συμπληρώματα μπορεί να βοηθήσουν στην ανάκαμψη. Τα BCAA μπορούν να μειώσουν τον μυϊκό πόνο και την κόπωση. Το μαγνήσιο βοηθά στη μυϊκή χαλάρωση και στην ποιότητα του ύπνου. Το ω-3 λιπαρά οξέα έχουν αντιφλεγμονώδεις ιδιότητες.</p>

        <h2>Προγραμματισμός Ημερών Ανάκαμψης</h2>
        <p>Η ενσωμάτωση ημερών ανάκαμψης στο πρόγραμμά σας είναι εξίσου σημαντική με τις ημέρες προπόνησης. Ένα ισορροπημένο πρόγραμμα θα πρέπει να περιλαμβάνει τουλάχιστον 1-2 πλήρεις ημέρες ανάκαμψης την εβδομάδα.</p>

        <h3>Ενεργητική Ανάκαμψη vs Παθητική Ανάκαμψη</h3>
        <p>Η παθητική ανάκαμψη σημαίνει πλήρη ανάπαυση - καμία προπόνηση καθόλου. Η ενεργητική ανάκαμψη περιλαμβάνει ελαφριά άσκηση που βελτιώνει την κυκλοφορία του αίματος χωρίς να προκαλεί επιπλέον καταπόνηση. Και οι δύο έχουν τη θέση τους σε ένα ισορροπημένο πρόγραμμα.</p>

        <h2>Συμπέρασμα</h2>
        <p>Η ανάκαμψη δεν είναι πολυτέλεια - είναι αναγκαιότητα. Αντιμετωπίστε τις ημέρες ανάκαμψής σας με την ίδια σοβαρότητα με τις ημέρες προπόνησής σας. Ακούστε το σώμα σας, δώστε προτεραιότητα στον ύπνο, φάτε σωστά και ενσωματώστε ενεργητικές τεχνικές ανάκαμψης. Θυμηθείτε, γίνεστε πιο δυνατοί όχι κατά την προπόνηση, αλλά κατά την ανάκαμψη. Η επένδυση στην ανάκαμψή σας θα οδηγήσει σε καλύτερες επιδόσεις, λιγότερους τραυματισμούς και μακροπρόθεσμη επιτυχία στα fitness goals σας.</p>
      `
    }
  };

  const post = posts[id];

  if (!post) {
    return (
      <div className="post-detail-container">
        <h1>Το άρθρο δεν βρέθηκε</h1>
        <Link to="/" className="btn btn-primary">Επιστροφή στην Αρχική</Link>
      </div>
    );
  }

  const handleShare = () => {
    setModalMessage('Η λειτουργία κοινοποίησης θα είναι σύντομα διαθέσιμη');
    setShowModal(true);
  };

  const handleFavorite = () => {
    toggleFavorite(post.id);
    const isFavorite = favorites.includes(post.id);
    setModalMessage(isFavorite ? 'Αφαιρέθηκε από τα αγαπημένα' : 'Προστέθηκε στα αγαπημένα');
    setShowModal(true);
  };

  const isFavorite = favorites.includes(post.id);

  return (
    <div className="post-detail-container">
      <Helmet>
        <title>{post.title} - Ecunel Fitness Gym</title>
        <meta name="description" content={post.content.substring(0, 160)} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.content.substring(0, 160)} />
        <meta property="og:image" content={`https://ecunel.com${post.image}`} />
        <meta property="og:type" content="article" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": post.title,
            "image": `https://ecunel.com${post.image}`,
            "datePublished": post.date,
            "author": {
              "@type": "Organization",
              "name": "Ecunel Fitness Gym"
            }
          })}
        </script>
      </Helmet>

      <div className="post-detail-header">
        <div className="post-meta">
          <span className="post-date">{post.date}</span>
          <span className="post-category">{post.category}</span>
        </div>
        <h1>{post.title}</h1>
      </div>

      <img src={post.image} alt={post.title} className="post-detail-image" />

      <div className="post-detail-content" dangerouslySetInnerHTML={{ __html: post.content }} />

      <div className="post-actions" style={{ marginTop: '3rem', justifyContent: 'center' }}>
        <button className="btn btn-secondary" onClick={handleShare}>
          Μοιραστείτε
        </button>
        <button 
          className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
          onClick={handleFavorite}
        >
          <FaHeart />
          {isFavorite ? 'Αγαπημένο' : 'Προσθήκη'}
        </button>
        <Link to="/" className="btn btn-primary">
          <FaShoppingCart />
          Περισσότερα Άρθρα
        </Link>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Ειδοποίηση</h2>
            <p>{modalMessage}</p>
            <button className="btn btn-primary" onClick={() => setShowModal(false)}>
              Κλείσιμο
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PostDetail;